import {
  broadcast,
  subscribe,
  TEventSubscribeHandler,
  TEventUnsubscribeHandler,
} from '@gem/modules/eventBus';

import { IEvent as ICalendarEvent } from 'APP/model/calendar/calendar.types';

const UPDATE_CALENDAR_EVENT_BUS_STATION = 'update-calendar-event';

export const subscribeUpdateCalendarEvent = (
  callback: TEventSubscribeHandler
): TEventUnsubscribeHandler => {
  return subscribe(UPDATE_CALENDAR_EVENT_BUS_STATION, callback);
};

export const broadcastUpdateCalendarEvent = (event: ICalendarEvent): void => {
  broadcast(UPDATE_CALENDAR_EVENT_BUS_STATION, event);
};
